/**
 * Plate editor plugin toggles shared by the three task-modal editors: the task
 * description, the new-comment composer, and an existing comment being edited.
 *
 * `link: true` exposes the toolbar's link button, which is the only route to
 * attaching a URL to selected text. `paragraphStyles` gates the headings and
 * blockquote dropdown and `todoList` gates the action-item button; both stay off.
 *
 * `image: true` registers the inline-image plugin: its element, its toolbar
 * button, and the deserializer that turns an incoming `<img>` into an image node.
 * It does nothing on its own — every insert path also needs an `imageAdapter`,
 * which is what supplies storage and is passed per surface. Turning this on
 * without one leaves the editor unable to upload or resolve anything, so the
 * button hides itself and pastes fall through to the host.
 *
 * Keep this a module-level constant and pass it by reference. `RichTextEditor`
 * memoizes its plugin list on this object's identity, and plate-core reacts to a
 * new plugin-list identity by reconfiguring the mounted editor — rebuilding every
 * plugin and re-deserializing the whole document. An inline object literal gets a
 * fresh identity on every render, so that work would repeat on each render of the
 * section, once per editor (a task with many comments mounts one per comment).
 */
export const TASK_MODAL_PLUGIN_TOGGLES = {
	link: true,
	paragraphStyles: false,
	todoList: false,
	image: true,
};
